export enum TextSize {
    SMALL = "sm",
    MEDIUM = "md",
    LARGE = "lg",
    EXTRA_LARGE = "xl",
}

const config = {
    [TextSize.SMALL]: { textWidth: 0.19 },
    [TextSize.MEDIUM]: { textWidth: 0.29 },
    [TextSize.LARGE]: { textWidth: 0.38 },
    [TextSize.EXTRA_LARGE]: { textWidth: 0.60 },
};

export default config;
